import React, { useState } from "react";
import styles from "./PreviewPhoto.module.scss";
import { ReactComponent as CameraIcon } from "assets/svg/camera-svgrepo-com.svg";
import InputTextArea from "components/shared/textArea/InputTextArea";
import { useForm } from "react-hook-form";
import OptionsModal from "components/shared/modal/OptionsModal/OptionsModal";
import CameraCaptureModal from "components/shared/modal/CameraCapture/CameraCaptureModal";
import camera from "../../../../../assets/svg/attach_photo.svg"
import { combineClasses } from "utils/utils";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
const PreviewPhoto = (props) => {
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const { register, handleSubmit, control } = useForm({});
  const [optionModalOpen, setOptionModalOpen] = useState(false);
  const [cameraModalOpen, setCameraModalOpen] = useState(false);
  const [imageData, setImageData] = useState([]);
  const [imageGalleryData, setImageGalleryData] = useState("");

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span style={{ display: "flex", alignItems: "center" }}>
            {" "}
            {props?.data?.required && <span style={{ color: "red" }}>*</span>}
            {props?.data?.value || props?.name || props?.label}
          </span>
          {props?.instructions || props?.data?.media?.length ? (
            <div>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>
        <div className={styles.rightContainer}>
          {imageData?.length > 0 ? (
            <div className={styles.photoAndAdd}>
              {imageData.map((image) => (
                <img src={image} alt="Captured" className={styles.image} />
              ))}
              <div
                className={styles.AddimageButton}
                onClick={() => setOptionModalOpen(true)}
              >
                <p>Attach Photo</p>
                <img alt="photo" src={camera} className={styles.cameraicon} />
              </div>
            </div>
          ) : imageGalleryData ? (
            <div className={styles.photoAndAdd}>
              <img
                src={imageGalleryData}
                alt="Gallery"
                className={styles.image}
              />
              <div
                className={styles.AddimageButton}
                onClick={() => setOptionModalOpen(true)}
              >
                {/* <CameraIcon className={styles.cameraicon} /> */}
                <p>Attach Photo</p>
                <img alt="photo" src={camera} className={styles.cameraicon} />

              </div>
            </div>
          ) : (
            <div
              className={styles.AddimageButton}
              onClick={() => setOptionModalOpen(true)}
            >
              {/* <CameraIcon className={styles.cameraicon} /> */}
              <p>Attach Photo</p>
              <img alt="photo" src={camera} className={styles.cameraicon} />

            </div>
          )}



          <div className={imageData?.length > 0 || imageGalleryData ? combineClasses(styles.textAreaField1, styles.textAreaField) : styles.textAreaField}>
            <InputTextArea
              control={control}
              type="textarea"
              name="Optional"
              placeholder="Add Caption for the photo"
              onChange={(e) => e}
              className={styles.textArea}
            />
          </div>
        </div>
        {showIcon && (
          <div className={styles.subContent}>
            {props?.instructions && (
              <div className={styles.instructionText}>
                {props?.instructions}
              </div>
            )}
            {props?.data?.media?.length ? (
              <>
                {props?.data?.media.map((image) => (
                  <img
                    className={styles.imageStyle}
                    src={image.path}
                    style={{ width: "100px", height: "100px" }}
                    alt="Preview"
                  />
                ))}
              </>
            ) : null}
          </div>
        )}

      </div>

      <OptionsModal
        optionModalOpen={optionModalOpen}
        setOptionModalOpen={setOptionModalOpen}
        setCameraModalOpen={setCameraModalOpen}
        setImageGalleryData={setImageGalleryData}
        setImageData={setImageData}
      />
      {cameraModalOpen && (
        <CameraCaptureModal
          setCameraModalOpen={setCameraModalOpen}
          cameraModalOpen={cameraModalOpen}
          setImageData={setImageData}
          imageData={imageData}
        />
      )}
    </div>
  );
};

export default PreviewPhoto;
